export const MAX_COL_SIZE = 12;
export const LAYOUT_CLASSES = ['ge-layout-desktop', 'ge-layout-tablet', 'ge-layout-phone'];
export const COL_CLASSES = ['col-lg-', 'col-sm-', 'col-'];
export let CURRENT_COL_CLASS_INDEX = 0 // Index of the column class we are manipulating currently

export default {
  create (size) {
    return $('<div class="column" />')
      .addClass(COL_CLASSES.map(function (c) {
        return c + size
      }).join(' '))
  },

  getTools(col, apendedRowContent, addContentEventHandler, settings) {
    return [
      {title:'Make column narrower (hold shift for min)', className: 'ge-decrease-col-width', iconClass: 'fa fa-minus', eventHandlers: function (e) {
          let colSizes = settings.valid_col_sizes,
            curColClass = COL_CLASSES[CURRENT_COL_CLASS_INDEX],
            curColSizeIndex = colSizes.indexOf(getColSize(col, curColClass)),
            newSize = colSizes[clamp(curColSizeIndex - 1, 0, colSizes.length - 1)]
          if (e.shiftKey) {
            newSize = colSizes[0]
          }
          setColSize(col, curColClass, Math.max(newSize, 1))
        }},
      {title:'Make column wider (hold shift for max)', className: 'ge-increase-col-width', iconClass: 'fa fa-plus', eventHandlers: function (e) {
          let colSizes = settings.valid_col_sizes,
            curColClass = COL_CLASSES[CURRENT_COL_CLASS_INDEX],
            curColSizeIndex = colSizes.indexOf(getColSize(col, curColClass)),
            newColSizeIndex = clamp(curColSizeIndex + 1, 0, colSizes.length - 1),
            newSize = colSizes[newColSizeIndex]
          if (e.shiftKey) {
            newSize = getColSize(col) + getColumnSpare(col.parent())
          }
          setColSize(col, curColClass, Math.min(newSize, MAX_COL_SIZE))
        }},
      {title:'Add row', className: 'ge-add-row', iconClass: 'fa fa-plus-circle', eventHandlers: function () {
          apendedRowContent.appendTo(col)
          col.click()
        }},
      {title:'+ Add content', className: 'ge-add-content', iconClass: 'fa fa-edit', eventHandlers: addContentEventHandler},
    ]
  },

  init (canvas) {
    canvas.find('.column, div[class*="col-"]').each(function () {
      let col = $(this)
      if (col.find('> .ge-tools-drawer').length) { return }
      fixColClasses (col)
    })
  },

  switchLayout (colClassIndex, canvas) {
    CURRENT_COL_CLASS_INDEX = colClassIndex

    LAYOUT_CLASSES.forEach(function (cssClass, i) {
      canvas.toggleClass(cssClass, i == colClassIndex)
    })
  }
}


function getColumnSpare (row) {
  return MAX_COL_SIZE - getColumnSizes(row)
}

function getColumnSizes (row) {
  let layout = COL_CLASSES[CURRENT_COL_CLASS_INDEX]
  let size = 0
  row.find('> [class*="' + layout + '"]').each(function () {
    size += getColSize($(this))
  })
  return size
}

/**
 * Return the column size for colClass, or a size from a different
 * class if it was not found.
 * Returns null if no size whatsoever was found.
 */
function getColSize (col, colClass) {
  let sizes = getColSizes(col)
  for (let i = 0; i < sizes.length; i++) {
    if (sizes[i].colClass == colClass) {
      return sizes[i].size
    }
  }
  if (sizes.length) {
    return sizes[0].size
  }
  return null
}

function getColSizes (col) {
  let result = []
  COL_CLASSES.forEach(function (colClass) {
    let re = new RegExp(colClass + '(\\d+)', 'i')
    if (re.test(col.attr('class'))) {
      result.push({
        colClass: colClass,
        size: parseInt(re.exec(col.attr('class'))[1])
      })
    }
  })
  return result
}

function setColSize (col, colClass, size) {
  let re = new RegExp('(' + colClass + '(\\d+))', 'i'),
      reResult = re.exec(col.attr('class'))
  if (reResult && parseInt(reResult[2]) !== size) {
    col.switchClass(reResult[1], colClass + size, 50)
  } else {
    col.addClass(colClass + size)
  }
}


function fixColClasses (col) {
  let size = 2
  let sizes = getColSizes(col)
  if (sizes.length) {
    size = sizes[0].size
  }

  let elemClass = col.attr('class')
  COL_CLASSES.forEach(function (colClass) {
    if (elemClass.indexOf(colClass) === -1) {
      col.addClass(colClass + size)
    }
  })

  col.addClass('column')
}

function clamp (input, min, max) {
  return Math.min(max, Math.max(min, input))
}
